<template>
	<div class="city-manager-placeholder">
    <Table :datas="datas" border>
      <TableItem :title="'部门编码'" prop="code" :width="80"></TableItem>
      <TableItem :title="'部门名称'" prop="name" :width="280"></TableItem>
      <TableItem title="城市经理">
        <template slot-scope="{data}">
          {{ getJingLiName(data.cusColumn15) }}
        </template>
      </TableItem>
      <TableItem title="操作" :width="120" align="center">
        <div class="actions" slot-scope="{data}">
          <span @click="edit(data)">编辑</span>
          <span @click="remove1(data)">清除</span>
        </div>
      </TableItem>
    </Table>

    <!-- 部门归属编辑弹窗：为部门指定/修改所属城市经理 -->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">编辑部门归属</div>
      <Form ref="form" v-width="500" :labelWidth="120" :model="form" :rules="validationRules">
        <FormItem label="部门编码" prop="code">
          <input type="text" v-model="form.code" disabled>
        </FormItem>
        <FormItem label="部门名称" prop="name">
          <input type="text" v-model="form.name" disabled>
        </FormItem>
        <FormItem label="城市经理" prop="cusColumn15">
          <Select v-model="form.cusColumn15" :datas="jingLiList" keyName="id" titleName="name"
                  multiple filterable placeholder="请选择城市经理"></Select>
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">更新</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>

	</div>
</template>
<script>
const emptyForm = {
  "code": "",
  "name": "",
  "cusColumn15": [],
  "enable": false
};
	/**
	 * 城市经理 - 「部门归属」标签页
	 * 占位页面，具体表格/表单/接口后续实现
	 */
	export default {
		name: "CityManagerDepartment",
    data() {
      return {

        // 存储表格展示的数据，初始为空数组
        datas: [],
        // 存储辅助核算类别的详细信息，初始为空对象
        category: {},
        // 表单数据对象，通过复制 emptyForm 对象初始化，避免直接修改原始对象
        form: Object.assign({}, emptyForm),
        // 表单验证规则，定义需要进行必填项验证的字段
        validationRules: {
          // 城市经理（cusColumn15）为必选项，使用自定义提示文案
          rules: {
            cusColumn15: {
              required: true,
              message: '请选择所属城市经理'
            }
          }
        },
        // 控制新增/编辑表单弹窗的显示与隐藏，false 表示隐藏
        showForm: false,
        // 控制按钮加载状态的布尔值，true 表示正在加载
        loading: false,
        // 城市经理下拉列表数据（来源于 /csjingli）
        jingLiList: [],
      };
    },
    watch: {
      // 弹窗关闭后重置表单，避免下次打开残留上一次的数据
      showForm(val) {
        if (!val) {
          this.reset();
        }
      }
    },

    methods: {
      /**
       * 初始化组件数据
       * 该方法会调用 API 获取当前辅助核算类别的详细信息，
       * 并根据返回的数据更新组件的 category 和 customColumns 属性，
       * 最后在 DOM 更新完成后加载数据列表。
       */
      init() {
        // 调用 API 获取全部辅助核算类别列表
        this.$api.setting.accountingCategory.list().then(async ({data}) => {
          // 从列表中找到 auxiliary 为"部门"的数据
          const department = (data || []).find(item => item.name === '部门');
          // 未找到部门类别时给出提示并中断后续流程
          if (!department) {
            this.$Message.error('未找到名为"部门"的辅助核算类别');
            return;
          }
          // 存储部门类别的详细信息
          this.category = department;
          // 先加载城市经理下拉数据，确保 loadList 渲染表格时能按 ID 正确反查名称
          await this.loadJingLi();
          // 在 DOM 更新完成后加载部门数据列表
          this.$nextTick(() => {
            this.loadList();
          });
        });
      },
      /**
       * 加载部门辅助核算明细列表数据
       * 依据当前部门类别的 id 获取其下的明细记录，并更新表格数据。
       */
      loadList() {
        // 开启加载状态
        this.loading = true;
        // 调用 API 获取该类别下的明细列表（分页数据取 records）
        this.$api.setting.accountingCategoryDetails.list(this.category.id).then(({data}) => {
          // this.datas = data.records || [];
          // 只显示 enable != 1 的部门（管理部门不展示）
          this.datas = (data.records || []).filter(item => item.enable != 1);
        }).finally(() => {
          // 无论成功失败都关闭加载状态
          this.loading = false;
        });
      },


      /**
       * 加载城市经理下拉列表数据
       * @returns {Promise} 返回 Promise，便于调用方 await 等待加载完成
       */
      loadJingLi() {
        return this.$api.report.jingLi.list().then(({data}) => {
          this.jingLiList = data || [];
        });
      },
      /**
       * 根据城市经理 ID 反查其名称（用于表格展示，支持多选）
       * @param {Array|Number|String} value 存储在 cusColumn15 中的城市经理 ID（数组或逗号分隔字符串）
       * @returns {String} 以顿号拼接的城市经理名称，未匹配到返回空字符串
       */
      getJingLiName(value) {
        if (value === undefined || value === null || value === '') {
          return '';
        }
        // 兼容数组与逗号分隔字符串两种形式
        const ids = Array.isArray(value) ? value : String(value).split(',');
        return ids
            .filter(id => id !== '' && id !== null && id !== undefined)
            .map(id => {
              const item = this.jingLiList.find(v => String(v.id) === String(id));
              return item ? item.name : '';
            })
            .filter(name => name !== '')
            .join('、');
      },
      /**
       * 打开编辑弹窗，并将当前行数据回填到表单
       * @param {Object} data 当前部门行数据
       */
      edit(data) {
        // 复制一份数据，避免直接修改表格中的原始对象
        this.form = Object.assign({}, data);
        // cusColumn15 存储的是城市经理 ID，统一类型以便下拉框正确回显选中项
        const raw = this.form.cusColumn15;
        if (raw !== undefined && raw !== null && raw !== '') {
          const ids = Array.isArray(raw) ? raw : String(raw).split(',');
          this.form.cusColumn15 = ids
              .filter(id => id !== '' && id !== null && id !== undefined)
              .map(id => {
                const matched = this.jingLiList.find(v => String(v.id) === String(id));
                return matched ? matched.id : id;
              });
        } else {
          this.form.cusColumn15 = [];
        }
        this.showForm = true;
      },

      /**
       * 提交表单：更新部门所属城市经理
       */
      submit() {
        // 表单校验：cusColumn15 未选择时会显示"请选择所属城市经理"提示
        let validResult = this.$refs.form.valid();
        if (validResult.result) {
          // 兜底：多选为空数组时 required 校验可能判定为"有值"，此处再拦截一次
          if (!this.form.cusColumn15 || !this.form.cusColumn15.length) {
            this.$Message.error('请选择所属城市经理');
            return;
          }
          this.loading = true;
          // 多选的城市经理 ID 数组序列化为逗号分隔字符串，并携带所属辅助核算类别 id 一并提交
          const params = Object.assign({
            accountingCategoryId: this.category.id
          }, this.form, {
            cusColumn15: Array.isArray(this.form.cusColumn15)
                ? this.form.cusColumn15.join(',')
                : this.form.cusColumn15
          });
          this.$api.setting.accountingCategoryDetails.update(params).then(() => {
            this.$Message.success('更新成功');
            // 更新成功后刷新列表并关闭弹窗
            this.loadList();
            this.showForm = false;
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        }
      },
      /**
       * 重置表单为初始空值
       */
      reset() {
        this.form = Object.assign({}, emptyForm);
      },

      /**
       * 清除该部门已关联的城市经理信息（仅清空归属，不删除部门本身）
       * @param {Object} data 当前部门行数据
       */
      remove1(data) {
        // 若该部门本就未关联城市经理，则无需清除
        if (data.cusColumn15 === undefined || data.cusColumn15 === null || data.cusColumn15 === '') {
          this.$Message.info('该部门尚未关联城市经理');
          return;
        }
        // 二次确认，避免误操作
        this.$Confirm('确认清除该部门的城市经理信息？').then(() => {
          this.loading = true;
          // 在原数据基础上将 cusColumn15 置空，并携带所属辅助核算类别 id 提交更新
          const params = Object.assign({}, data, {
            accountingCategoryId: this.category.id,
            cusColumn15: ''
          });
          this.$api.setting.accountingCategoryDetails.update(params).then(() => {
            this.$Message.success('清除成功');
            // 清除成功后刷新列表
            this.loadList();
          }).finally(() => {
            // 无论成功失败都关闭加载状态
            this.loading = false;
          });
        });
      },

    },

    mounted() {
      this.init();
    },
	};
</script>
<style lang='less' scoped>
	.city-manager-placeholder {
		.placeholder-tip {
			color: #999999;
			text-align: center;
			padding: 40px 0;
		}
	}
</style>
